import React, { createContext, useContext, useEffect, useState } from 'react';
import { Language, Translation, translations } from '../data/translations';
interface LanguageContextValue {
  lang: Language;
  setLang: (lang: Language) => void;
  t: Translation;
}
const STORAGE_KEY = 'rewayz-lang';
const LanguageContext = createContext<LanguageContextValue | null>(null);
function getInitialLanguage(): Language {
  if (typeof window === 'undefined') return 'fr';
  const stored = window.localStorage.getItem(STORAGE_KEY);
  return stored === 'en' || stored === 'fr' ? stored : 'fr';
}
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLang] = useState<Language>(getInitialLanguage);
  useEffect(() => {
    document.documentElement.lang = lang;
    window.localStorage.setItem(STORAGE_KEY, lang);
  }, [lang]);
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t: translations[lang]
  }} data-id="element-114" data-mp="2ellwx80qhf3u">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage(): LanguageContextValue {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}